import { render, staticRenderFns } from "./SortChevrons.vue?vue&type=template&id=58523097&scoped=true"
import script from "./SortChevrons.vue?vue&type=script&lang=js"
export * from "./SortChevrons.vue?vue&type=script&lang=js"
import style0 from "./SortChevrons.vue?vue&type=style&index=0&id=58523097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58523097",
  null
  
)

export default component.exports